import { useRef, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Headers from './Headers';
import $ from 'jquery';
import 'datatables.net-dt/js/dataTables.dataTables';
import 'datatables.net-dt/css/jquery.dataTables.min.css';
import '../App.css';
import Axios from '../api/axios';

const CashReport = () => {
  let navigate = useNavigate();
  const firstUserLoggedInSessionExpired = localStorage.getItem('loggedIn');
  let secondUserLoggedInSessionExpired = JSON.parse(firstUserLoggedInSessionExpired);

  useEffect(() => {
    if (secondUserLoggedInSessionExpired === 'No') {
      navigate('/Logout');
    }
  }, []);

  let loggedIn = sessionStorage.getItem('loggedIn');
  loggedIn = JSON.parse(loggedIn);
  if (loggedIn === 'No' || loggedIn === '') {
    navigate('/Logout');
  }

  const [DBtableViewCashReport, setDBtableViewCashReport] = useState([]);

  const server_app_api_php = window.SERVER_APP_API_PHP;
  
  useEffect(() => {
    const fetchData = () => {
      const formDataCashReport = new FormData();
      formDataCashReport.append('apiType', 'getViewCashReport');
      // Add additional form data depending on user position
      Axios.post(`${server_app_api_php}/index.php`, formDataCashReport)
        .then((response) => {
          setDBtableViewCashReport(response.data);
          // Initialize DataTable after data has been set
          $(document).ready(function () {
            $('#cashReportTable').DataTable({
              paging: true,
              searching: true,
              lengthMenu: [10, 25, 50, 100],
            });
          });
        })
        .catch((error) => {
          console.error('There was an error fetching the data!', error);
        });
    };
    
    fetchData();
    
    // Clean up function to destroy the DataTable instance
    return () => {
      $('#cashReportTable').DataTable().destroy(true);
    };
  }, []);

  return (
    <header>
      <>
        <title>
          KANCH INNOVATIVE TECHNOLOGIES - Sales By Cash Report
        </title>
        <Headers />
        <div className="container mt-5">
          <h6 className="form-header white-text ocean blue-gradient">CASH REPORT</h6>
          <table id="cashReportTable" className="display" style={{ width: '100%' }}>
            <thead>
              <tr>
                <th>SN</th>
                <th>Store</th>
                <th>Date</th>
                <th>Item</th>
                <th>Quantity</th>
                <th>Unit Cost</th>
                <th>Unit Price</th>
                <th>Total Sale</th>
                <th>Profit</th>
                <th>Cashier</th>
              </tr>
            </thead>
            <tbody>
              {DBtableViewCashReport.map((row, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{row.branch_name}</td>
                  <td>{row.pos_date}</td>
                  <td>{row.product}</td>
                  <td>{row.unit_quantity}</td>
                  <td>{row.product_unit_cost}</td>
                  <td>{row.product_unit_price}</td>
                  <td>{row.product_total_price}</td>
                  <td>{row.profit}</td>
                  <td>{row.cashier}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </>
    </header>
  );
};

export default CashReport;
